// extracted by mini-css-extract-plugin
export default {"subrayado":"Titulo_subrayado__D+nWj","titulo":"Titulo_titulo__MUxfv"};